import styled from 'styled-components';

export const StyledDiv = styled.div`  
  margin-top: -4px;
  margin-bottom: 8px;
  font-size:14px;

  span {
    margin-top: 3px;

    svg {
      float: left;
      top: -1px;
    }
  }
`;
